import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';

//const [medsheet, setMedSheet] = useState([]);


const PatientProfileReport = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [hcporderrpt, setHcpOrder] = useState("");
    const [hcpoptions, setHcpOptions] = useState([]);
    const [spinner, showSpinner] = useState(false);
    const [hcpError, setHcpError] = useState(false);
    const [reportFormatError, setReportFormatError] = useState(false);
    const [formData, setFormData] = useState({
        hcp: '',
        reportformat: ''
    });

    const { programId } = useParams();

    const [reportdate, setReportDate] = useState(null);
    const [showResults, setShowResults] = React.useState(false)
    // const [hcpoptions, setHcpOptions] = useState([]);
    useEffect(() => {
        if (spinner) {
            setShowResults(false);
        }
    }, [spinner])

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        showSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsHcpOrderUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/med-profile-report";

        let pelmedsHcpOrderData = {
            patient_id: localStorage.getItem("patientId"),
        }

        if (programId) {
            pelmedsHcpOrderData.day_program_id = programId;
        }

        showSpinner(false);

        try {
            const response = await axios.post(pelmedsHcpOrderUrl, pelmedsHcpOrderData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (!(response.data.status)) {
                setError(response.data.message);
            }
            const { blobUrl } = await createIframeReportBlobUrl(response.data);
            setIframeSrc(blobUrl);
        } catch (err) {
            setError("Failed to print content.");
        } finally {
            setLoading(false);
        }
    }


    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleHcpChange = e => {
        setFormData({
            ...formData,
            'hcp': e.value
        });
    };

    return (
        <>
            <div style={{
                height: 0,
                overflow: 'hidden',
                // width: 0
            }}>
                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        style={{ width: "100%", height: "500px", border: "none" }}
                        title="Preview Content"
                    />
                )}
            </div>
            <Form>
                <div className="text-end px-3 mt-3">
                    {!loading ? <Button className="btn btn-primary" onClick={handleSubmit}>
                        Generate
                    </Button> : <Spinner animation="border" role="status" size="sm"></Spinner>}
                </div>
            </Form>
            <div>
                <br />
                {showResults && (
                    <a href={hcporderrpt} target="_blank" rel="noreferrer">
                        <button className="btn btn-primary">
                            📄 Download Report
                        </button>
                    </a>
                )}

            </div>
        </>
    );
};

PatientProfileReport.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

PatientProfileReport.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default PatientProfileReport;

